import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";

import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { GeneralResponse } from "../../../types/api";
import { IForgetPasswordCheckCodeRequest } from "../../../types/apis/auth-apis";

export const ForgetPasswordCheckCode = async (
  payload: IForgetPasswordCheckCodeRequest,
): Promise<GeneralResponse> => {
  try {
    const response = await Api<
      any,
      GeneralResponse<IForgetPasswordCheckCodeRequest>
    >({
      method: Methods.POST,
      endpoint: EndPoints.ForgetPasswordVerifyOTP,
      body: payload,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useForgetPasswordCheckCode = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    IForgetPasswordCheckCodeRequest
  > = useMutation({
    mutationFn: ForgetPasswordCheckCode,
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
